<div
  id="attachments"
  class="relative mr-2 flex h-[120px] flex-col gap-2 rounded-md border border-solid border-gray-300 p-2 py-2"
  (click)="!isDetails && openFileSelector($event)">
  <div class="flex justify-between">
    <div class="title w-full font-bold" id="titleAttachments">
      {{ attachmentFiles.length ? attachmentFiles.length : '' }}
      {{ 'attachment' | translate }}
      ({{ getSize() | formatSize: 2 }})
    </div>
    @if (attachmentFiles.length) {
      @if (!isLoadingDownload) {
        <button
          mat-icon-button
          matTooltip="{{ 'downloadAttachments' | translate }}"
          (click)="emailId && downloadAllFiles(emailId)">
          <mat-icon>file_download</mat-icon>
        </button>
      } @else {
        <div class="flex h-[40px] w-[40px] items-center justify-center">
          <mat-progress-spinner
            mode="indeterminate"
            diameter="24"></mat-progress-spinner>
        </div>
      }
    }
  </div>
  <div class="attachments">
    <div id="containerAttachments" class="flex flex-wrap justify-start gap-y-2">
      @for (file of attachmentFiles; track file) {
        @if (!isDetails) {
          <div
            [matTooltip]="
              !file.fileId ? ('uploadFileAndScanForVirus' | translate) : null
            "
            class="file">
            <span
              class="leading-1 break-all px-[3px] text-[12px] underline underline-offset-4 hover:text-primary hover:decoration-primary lg:text-[14px]"
              (click)="
                file.fileId &&
                  !isFileDownloading(file?.fileId) &&
                  emailId &&
                  getAttachmentFile(file, emailId)
              "
              [style.cursor]="
                file.fileId && !isFileDownloading(file?.fileId)
                  ? 'pointer'
                  : 'default'
              "
              [style.color]="
                file.fileId && !isFileDownloading(file?.fileId) ? '' : 'grey'
              "
              style="overflow-wrap: anywhere">
              {{ file.fileName }}
              @if (file.size) {
                ({{ file.size | formatSize: 2 }})
              }
            </span>
            <div class="flex h-[24px] items-center justify-end">
              @if (file.fileId && !isFileDownloading(file?.fileId)) {
                <div
                  class="flex cursor-pointer items-center justify-center rounded-full p-1 hover:bg-red-100"
                  (click)="deleteFileAttachment(file)">
                  <mat-icon class="small" color="warn" mat-icon-button
                    >close</mat-icon
                  >
                </div>
              }
              @if (!file.fileId || isFileDownloading(file?.fileId)) {
                <mat-progress-spinner
                  class="w-[24px]"
                  mode="indeterminate"
                  diameter="16"></mat-progress-spinner>
              }
            </div>
          </div>
        } @else {
          <div class="file">
            @if (
              file.fileState === attachmentState.CheckInProgress ||
              file.fileState === attachmentState.Uploaded
            ) {
              <mat-icon
                [matTooltip]="'scaningForVirus' | translate"
                style="
                  transform: scale(0.65);
                  color: rgb(233, 162, 21);
                  cursor: default;
                "
                mat-icon-button>
                bolt
              </mat-icon>
            }
            <span
              (click)="
                !isFileDownloading(file?.fileId) &&
                  emailId &&
                  getAttachmentFile(file, emailId)
              "
              [style.color]="!isFileDownloading(file?.fileId) ? '' : 'grey'"
              class="attach-text break-all text-[12px] underline underline-offset-4 lg:text-[14px]"
              [style.cursor]="
                !isFileDownloading(file?.fileId) ? 'pointer' : 'default'
              ">
              {{ file.fileName }}
              @if (file.size) {
                ({{ file.size | formatSize: 2 }})
              }
            </span>
            @if (isFileDownloading(file?.fileId)) {
              <mat-progress-spinner
                class="ml-[3px] w-[24px]"
                mode="indeterminate"
                diameter="16"></mat-progress-spinner>
            }
          </div>
        }
      }
    </div>
  </div>
</div>
@if (!isDetails || !useTabletView) {
  <ngx-file-drop
    #uploader
    [disabled]="disabled"
    (onFileLeave)="resetIsDragging.emit()"
    [multiple]="true"
    dropZoneLabel="Drop files here"
    (onFileDrop)="onDrop($event)"
    dropZoneClassName="absolute h-full top-0 left-0 w-full {{
      isDragging ? 'z-10' : 'z-[-1]'
    }}"
    contentClassName="h-full w-full">
    <ng-template ngx-file-drop-content-tmp></ng-template>
  </ngx-file-drop>
}
